<template>
    <Head title="Meu Perfil" />
    <AuthenticatedLayout>
        <Heading title="Meu Perfil" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28" />
        <form
            class="component-background-mobile pt-10 pb-14 px-4 xl:px-[16vw]"
        >
            <div class="max-w-[873px]">
                <section>
                    <h2 class="text-3xl font-semibold text-left">
                        Preferências
                    </h2>
                    <div class="mt-3">
                        <label class="flex font-bold">Foto</label>
                        <img
                            v-if="photo"
                            :src="photo"
                            class="mt-2 max-w-[138px] max-h-[138px]"
                            alt=""
                        />
                        <div
                            v-if="!photo"
                            class="mt-2 flex justify-center items-center w-[138px] h-[138px] bg-[#EDEEF0] border border-primary border-dashed"
                        >
                            <Icon name="Perfil" />
                        </div>
                        <div class="flex">
                            <p
                                class="mt-2 text-indigo-500 cursor-pointer"
                                @click="changePhoto"
                            >
                                Trocar Imagem
                            </p>
                            <input
                                type="file"
                                class="hidden"
                                id="inputImg"
                                @input="loadPhoto"
                            />
                        </div>
                    </div>
                    <div class="mt-3">
                        <label class="flex gap-x-1 font-bold"
                            >Apelido<span class="text-red-600">*</span></label
                        >
                        <span class="text-[14px]"
                            >Como você gostaria de ser chamado?</span
                        >
                        <Input
                            required
                            placeholder="Preecha aqui o seu apelido.."
                            ref="nickname"
                            type="text"
                            maxlength="40"
                            class="mt-2"
                            id="nickname"
                            v-model="this.form.nickname"
                        />
                    </div>
                </section>

                <section class="pt-10">
                    <h2 class="text-3xl font-semibold text-left text-primary">
                        Perfil
                    </h2>
                    <div class="mt-3">
                        <label for="name" class="flex font-bold gap-x-1"
                            >Nome Completo<span class="text-red-600"
                                >*</span
                            ></label
                        >
                        <Input
                            required
                            name="name"
                            placeholder="João da Silva"
                            maxlength="70"
                            type="text"
                            v-model="this.form.name"
                        />

                        <!-- <label for="fullname" class="flex font-bold mt-3 text-primary">Sobrenome completo</label>
                        <Input required name="name" placeholder="da Silva" maxlength="70" type="text" v-model="this.form.fullname" /> -->
                        <!-- <label class="flex font-bold mt-3"> CPF<span class="text-red-600">*</span></label>
                        <Input placeholder="000.000.000-00"
                            @keyup="formatCpf"
                            id="cpf"
                            type="text"
                            v-model="this.form.cpf"
                            maxlength="14"
                            required
                            :state="stateCpf"
                            autocomplete="cpf"
                        /> -->

                        <!-- <label class="flex font-bold mt-3">CPF</label>
                        <span
                            >Seu CPF cadastrado é o
                            <strong>{{ form.cpf}}</strong></span
                        > -->

                        <label
                            class="flex gap-x-1 font-bold after:content-['*'] after:text-error mt-3"
                            >CPF
                        </label>
                        <Input
                            placeholder="000.000.000-00"
                            @keyup="formatCpf"
                            id="cpf"
                            type="text"
                            v-model="form.cpf"
                            maxlength="14"
                            required
                            autocomplete="cpf"
                        />

                        <label class="flex font-bold mt-3"
                            >Data de Nascimento</label
                        >
                        <Input
                            class="max-w-[153px]"
                            name="birthDate"
                            placeholder="DD / MM / AAAA"
                            @keydown="formatDate"
                            @change="formatDate"
                            :state="ageError ? 'error' : 'success'"
                            type="text"
                            v-model="form.dob"
                        />

                        <label class="flex font-bold mt-3">Código SAP</label>
                        <Input
                            name="sap"
                            placeholder="00000000"
                            type="text"
                            v-model="profile.codeSap"
                            disabled
                        />

                        <label class="flex font-bold mt-3">Cargo</label>
                        <Input
                            name="role"
                            placeholder="Cargo"
                            type="text"
                            v-model="computedJobTitle"
                            disabled
                        />

                        <div v-if="pdv">
                            <label class="flex font-bold mt-3">Regional</label>
                            <Input
                                name="region"
                                placeholder="Região"
                                type="text"
                                v-model="pdv.region"
                                disabled
                            />
                        </div>

                        <div v-if="pdv">
                            <label class="flex font-bold mt-3"
                                >Subregional</label
                            >
                            <Input
                                name="filial"
                                placeholder="Filial"
                                type="text"
                                v-model="pdv.subregion"
                                disabled
                            />
                        </div>

                        <!-- <Input required placeholder="Ex: 123.456.789-10" type="text" v-model="profile.cpf"/> -->
                        <!-- <span class="text-primary font-bold">Seu CPF cadastrado é o <strong>{{ hideCpf(profile.cpf) }}</strong></span> -->
                        <!--
                        <label for="phoneNumber" class="flex font-bold mt-3 text-primary">Broker</label>
                        <Input name="phoneNumber" placeholder="" type="text" :modelValue="profile.pdv?.name" disabled/> -->
                        <!-- {{profile.pdv}} -->
                        <!-- <span class="text-primary font-semibold text-xs">* Caso seu Broker ou Cargo esteja incorreto, entre em contato através do <a href="/contact" class="text-primary underline hover:text-blue-500">Fale Conosco</a>.</span> -->
                    </div>
                </section>

                <section class="pt-10">
                    <h2 class="text-3xl font-semibold text-primary text-left">
                        Contato
                    </h2>

                    <label for="phoneNumber" class="flex font-bold mt-3"
                        >Celular</label
                    >

                    <Input
                        required
                        name="phoneNumber"
                        placeholder="(00) 00000-0000"
                        type="text"
                        @keypress="formatPhoneNumber"
                        v-model="this.form.mobile"
                    />

                    <label for="instagram" class="flex font-bold mt-3"
                        >Instagram</label
                    >
                    <div class="flex items-center gap-x-2">
                        <span class="text-primary text-xl font-bold">@</span>
                        <Input
                            name="instagram"
                            placeholder="nomedouser"
                            type="text"
                            v-model="this.form.instagram"
                        />
                    </div>

                    <label class="flex font-bold mt-3 gap-x-1">
                        Endereço de Email
                        <span class="text-red-600">*</span></label
                    >
                    <span
                        >Seu endereço de email é
                        <strong>{{ $page.props.auth.user.email }}</strong></span
                    >
                </section>

                <section class="pt-10">
                    <h2 class="text-3xl font-semibold text-primary text-left">
                        Privacidade
                    </h2>

                    <label
                        for="phoneNumber"
                        class="flex font-bold mt-3"
                    ></label>
                    <label class="flex items-center gap-x-1">
                        <input
                            type="checkbox"
                            v-model="this.form.isVisibleBalance"
                        />
                        Habilitar Visualização do Saldo
                    </label>
                </section>

                <section class="pt-10">
                    <h2 class="text-3xl font-semibold text-primary text-left">
                        Endereço
                    </h2>
                    <div class="mt-3">
                        <div class="flex flex-col">
                            <label class="flex font-bold mt-3"
                                >CEP<span class="text-red-600">*</span></label
                            >
                            <Input
                                required
                                placeholder="00000-000"
                                type="text"
                                maxlength="9"
                                @keypress="formatPostalCode"
                                @input="getAdress"
                                v-model="this.form.address.zipCode"
                            />
                            <a
                                class="text-blue-600"
                                href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                                >Não sei meu CEP</a
                            >
                        </div>

                        <label for="adress" class="flex font-bold mt-3">
                            Endereço<span class="text-red-600">*</span>
                        </label>
                        <Input
                            required
                            name="adress"
                            placeholder="Rua das Flores"
                            type="text"
                            v-model="this.form.address.address"
                        />

                        <label class="flex font-bold mt-3">
                            Número<span class="text-red-600">*</span>
                        </label>
                        <Input
                            required
                            placeholder="123"
                            type="text"
                            @keypress="onlyNumbers"
                            v-model="this.form.address.number"
                        />

                        <label for="complement" class="flex font-bold mt-3">
                            Complemento
                        </label>
                        <Input
                            name="complement"
                            placeholder="Casa, Apartamento, Quadra..."
                            type="text"
                            v-model="this.form.address.complement"
                        />

                        <label for="district" class="flex font-bold mt-3">
                            Bairro<span class="text-red-600">*</span>
                        </label>
                        <Input
                            required
                            name="district"
                            placeholder="São José"
                            type="text"
                            v-model="this.form.address.district"
                        />

                        <label class="flex font-bold mt-3"
                            >Cidade<span class="text-red-600">*</span></label
                        >
                        <Autocomplete
                            required
                            :states="municipios"
                            @updateValue="this.form.address.city = $event"
                            :initialValue="this.form.address.city"
                        />

                        <label class="flex font-bold mt-3"
                            >Estado<span class="text-red-600">*</span></label
                        >
                        <Select
                            required
                            placeholder="Selecione um estado"
                            :options="states"
                            class="!w-full border"
                            v-model="this.form.address.state"
                        />
                    </div>
                </section>
                <div class="my-4">
                    <p
                        v-for="(error, key) in errors"
                        :key="key"
                        class="text-red-600"
                    >
                        {{ error }}
                    </p>
                    <!-- <p class="text-red-600">{{ $page.props.flash.error }}</p> -->
                    <p v-if="ageError" class="text-red-600">Idade incorreta</p>
                </div>
                <Button @click.prevent="submit">Salvar</Button>

                <p class="mt-8">
                    <span class="text-red-600">*</span>
                    Campos obrigatórios
                </p>
                <section class="flex flex-col gap-y-8 mt-8">
                    <div class="flex flex-col gap-y-2">
                        <h2
                            class="text-3xl font-semibold text-primary text-left"
                        >
                            Multiplo Fator de Autenticação
                        </h2>
                        <a
                            class="text-blue-500"
                            :href="route('my-profile.mfa.index')"
                            >Gerênciar</a
                        >
                    </div>
                    <div class="flex flex-col gap-y-2">
                        <h2
                            class="text-3xl font-semibold text-primary text-left"
                        >
                            Senha
                        </h2>
                        <a
                            class="text-blue-500"
                            href="/my-profile/enter-password"
                            >Alterar Senha</a
                        >
                    </div>
                    <div class="flex flex-col gap-y-2">
                        <h2
                            class="text-3xl font-semibold text-primary text-left"
                        >
                            Meus Resgates
                        </h2>
                        <a
                            class="text-blue-500"
                            :href="$page.props.auth.user.urlReconhece"
                            >Verificar meus resgates</a
                        >
                    </div>
                    <div class="flex flex-col gap-y-2">
                        <h2
                            class="text-3xl font-semibold text-primary text-left"
                        >
                            Fale Conosco
                        </h2>
                        <a class="text-blue-500" href="/contact"
                            >Acessar o Fale Conosco</a
                        >
                    </div>
                    <div class="flex flex-col gap-y-2">
                        <h2
                            class="text-3xl font-semibold text-primary text-lef"
                        >
                            Push Notification
                        </h2>
                        <a
                            class="text-blue-500"
                            :href="route('dashboard-push-notification')"
                            >Gerenciar dispositivos</a
                        >
                    </div>
                    <div class="flex flex-col gap-y-2">
                        <h2
                            class="text-3xl font-semibold text-primary text-left"
                        >
                            Sair
                        </h2>
                        <a
                            class="text-blue-500 cursor-pointer"
                            @click="this.showModalLogout = true"
                            >Clique para sair da plataforma</a
                        >
                    </div>
                </section>
            </div>
        </form>
    </AuthenticatedLayout>
    <transition>
        <div
            v-if="showModalLogout"
            class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
        >
            <div
                class="bg-white border-[1px] border-primary rounded-[4px] w-2.5/12 px-4 py-4 leading-9"
            >
                <button class="float-right" @click="showModalLogout = false">
                    <Icon name="Fechar" />
                </button>
                <h1 class="text-[20px] font-bold text-primary">Sair</h1>
                <p class="text-[16px] leading-6">
                    Você tem certeza que quer sair da plataforma?
                </p>
                <div class="flex justify-center gap-x-6 mt-5">
                    <Button
                        @click="showModalLogout = false"
                        class="max-w-[102px]"
                    >
                        Cancelar
                    </Button>
                    <ButtonDark class="max-w-[156px]">
                        <a href="/logout">Sim, quero sair</a>
                    </ButtonDark>
                </div>
            </div>
        </div>
    </transition>
    <transition v-if="flashMessage">
        <div
            class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
        >
            <div
                class="bg-white border-[1px] border-primary rounded-[4px] w-2.5/12 px-4 py-4 leading-9"
            >
                <button
                    class="float-right"
                    @click="$page.props.flash = { success: '', error: '' }"
                >
                    <Icon name="Fechar" />
                </button>
                <h1 class="text-[20px] font-bold text-primary">
                    {{ flashMessage.title }}
                </h1>
                <p class="text-[16px] leading-6">
                    {{ flashMessage.description }}
                </p>
            </div>
        </div>
    </transition>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import { Head } from "@inertiajs/inertia-vue3";
import Heading from "@/Components/UI/Texts/Heading.vue";
import Input from "@/Components/UI/Form/InputWithoutIcon.vue";
import Select from "@/Components/UI/Form/Select.vue";
import Autocomplete from "@/Components/Autocomplete.vue";
import {
    formatPhoneNumber,
    formatLandLine,
    onlyNumbers,
    formatPostalCode,
    formatCpf,
    formatDate,
    formatBirthDate,
} from "@/Helpers/masks";
import axios from "axios";
import Button from "@/Components/Button.vue";
import ButtonDark from "@/Components/ButtonDark.vue";

export default {
    components: {
        AuthenticatedLayout,
        Head,
        Heading,
        Icon,
        Input,
        Select,
        Autocomplete,
        Button,
        ButtonDark,
    },
    props: {
        photo: Object,
        profile: Object,
        address: Object,
        pdv: Object,
        updateMessage: String,
        isVisibleBalance: Object,
    },
    data() {
        return {
            errors: [],
            ageError: false,
            data: this.profile,
            form: this.$inertia.form({
                id: this.profile.id,
                photo: "",
                name: this.profile.name,
                nickname: this.profile.nickname,
                cpf: this.formatInitialCpf(this.profile.cpf),
                dob: "",
                instagram: this.profile.instagram,
                mobile: this.profile.mobile,
                pdv: this.profile?.pdv,
                isVisibleBalance: this.isVisibleBalance,
                address: {
                    id: this.address?.id,
                    zipCode: this.address?.zipCode,
                    address: this.address?.address,
                    number: this.address?.number,
                    complement: this.address?.complement,
                    district: this.address?.district,
                    city: this.address?.city,
                    state: this.address?.state,
                },
            }),
            showSuccessUpdate: false,
            showModalLogout: false,
            // deletePerfilModal: false,
            // confirmDelete: false,
            modelValue: "",
            states: [
                "AC",
                "AL",
                "AP",
                "AM",
                "BA",
                "CE",
                "DF",
                "ES",
                "GO",
                "MA",
                "MS",
                "MT",
                "MG",
                "PA",
                "PB",
                "PR",
                "PE",
                "PI",
                "RJ",
                "RN",
                "RS",
                "RO",
                "RR",
                "SC",
                "SP",
                "SE",
                "TO",
            ],
        };
    },
    watch: {
        profile: {
            handler(value) {
                if (value) {
                    this.birthDate;
                }
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        birthDate() {
            this.form.dob = this.profile.dob
                ? formatBirthDate(this.profile.dob)
                : "";
        },
        flashMessage() {
            if (this.$page.props.flash.error) {
                return this.$page.props.flash.error;
            }

            if (this.$page.props.flash.success) {
                return this.$page.props.flash.success;
            }

            return false;
        },
        computedJobTitle() {
            const jobTitle = this.profile?.jobTitle?.toLowerCase();

            if (["repositor", "promotor"].includes(jobTitle)) {
                return "MERCHANDISER";
            }

            return this.profile.jobTitle;
        },
    },
    methods: {
        changePhoto() {
            document.body.querySelector("#inputImg").click();
        },
        confirm() {
            this.confirmDelete = true;
            this.deletePerfilModal = false;
        },
        quit() {
            location.href = "/logout";
        },
        submit() {
            let inputs = document.getElementsByTagName("Input");
            this.errors = [];

            for (var i = 1; i < inputs.length; i++) {
                if (inputs[i].hasAttribute("required")) {
                    if (!inputs[i].value) {
                        inputs[i].classList.add("border-error");
                        inputs[i].classList.remove("border-gray-800");
                        this.errors = [];
                        this.errors.push(`Preencha todos os campos`);
                        console.log(inputs[i]);
                    } else {
                        inputs[i].classList.remove("border-error");
                        inputs[i].classList.add("border-gray-800");
                    }
                }
            }

            let arrBirthDate = this.form.dob.split("/");
            let date = new Date(
                arrBirthDate[2],
                arrBirthDate[1] - 1,
                arrBirthDate[0]
            );

            if (this.form.dob && this.form.dob.trim() !== "")
                this.ageError = !this.verifyAge(new Date(date));
            else this.ageError = false;

            if (this.errors.length === 0 && !this.ageError) {
                let formPost = {};

                Object.assign(formPost, this.form);
                formPost.cpf = formPost.cpf
                    .replace(".", "")
                    .replace(".", "")
                    .replace("-", "");

                let split = formPost.dob.split("/");

                if (formPost.dob && formPost.dob.trim() !== "")
                    formPost.dob = `${split[2]}-${split[1]}-${split[0]}`;

                axios
                    .post("/register/validate", {
                        cpf: this.form.cpf
                            .replace(".", "")
                            .replace(".", "")
                            .replace("-", ""),
                    })
                    .then((response) => {
                        if (response.data.success === true) {
                            this.errors.push(
                                "Cpf em uso por outro participante"
                            );
                        } else {
                            formPost.post("my-profile", {
                                preserveScroll: true,
                                onSuccess: () => {
                                    this.showSuccessUpdate = true;
                                },
                            });
                        }
                    });
            }
        },
        changePassword() {
            this.$inertia.post("/forgot-password", this.form.email);
        },
        verifyAge(birthDate) {
            let dateNow = new Date();

            let yearDif = dateNow.getFullYear() - birthDate.getFullYear();
            let monthDif = dateNow.getMonth() - birthDate.getMonth();
            let dateDif = dateNow.getDate() - birthDate.getDate();

            if (yearDif < 18 || yearDif > 99) {
                return false;
            }
            if (yearDif > 18) {
                return true;
            }
            if (yearDif == 18) {
                if (monthDif > 0) {
                    return true;
                }
                if (monthDif < 0) {
                    return false;
                }
                if (monthDif == 0) {
                    if (dateDif >= 0) {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        // hideCpf(cpf) {
        //     cpf = cpf.replace(/\D/g, "");
        //     cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
        //     cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
        //     cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

        //     cpf.substr(0, 14);
        //     cpf = cpf.replace(/(\d{3})/, "***");
        //     cpf = cpf.replace(/(\d{3})/, "***");
        //     return cpf;
        // },
        getAdress() {
            if (this.form.address.zipCode.length === 9) {
                const zipCodeFormat = this.form.address.zipCode.replace(
                    "-",
                    ""
                );

                axios
                    .get(`https://viacep.com.br/ws/${zipCodeFormat}/json/`)
                    .then((res) => {
                        this.form.address.address = res.data.logradouro;
                        this.form.address.complement = res.data.complemento;
                        this.form.address.district = res.data.bairro;
                        this.form.address.city = res.data.localidade;
                        this.form.address.state = res.data.uf;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        imprimir(x) {
            console.log(x);
        },
        loadPhoto(e) {
            this.selectErrors = [];

            this.file = e.target.files[0];

            let formData = new FormData();
            formData.append("file", this.file);
            formData.append("id", this.form.id);

            this.$inertia.post("my-profile/photo", formData, {
                headers: { "content-type": "multipart/form-data" },
                onSuccess: () => {
                    location.reload();
                },
            });
        },
        formatInitialCpf(cpf) {
            if (!cpf) return "";

            cpf = cpf.replace(/\D/g, "");
            cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
            cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
            cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

            cpf.substr(0, 14);
            return cpf;
        },

        formatPhoneNumber,
        formatLandLine,
        onlyNumbers,
        formatPostalCode,
        formatCpf,
        formatDate,
        formatBirthDate,
    },
};
</script>
